import React from 'react'
import { Authorization } from './'

export const Route = ({ allowedRoles, component: Component, ...props }) => {
  const renderComponent = <Component {...props} />
  if (!allowedRoles) {
    return renderComponent
  }
  return (
    <Authorization showPlaceholder allowedRoles={allowedRoles}>
      {renderComponent}
    </Authorization>
  )
}
